<template>
  <div>
    <section class="banner-home">
      <div class="banner-content">
        <h1>CATENA SYSTEM</h1>
        <h2>Soluções de TI sob medida</h2>
        <p>Desenvolvemos sistemas e aplicativos que simplificam processos e aceleram resultados</p>
        <a href="https://wa.me/553189344230" target="_blank">
          <button class="cta-button">Vamos conversar?</button>
        </a>
      </div>
    </section>

    <section class="section-itens">
      <h2>Soluções de TI que impulsionam seu negócio</h2>
      <div class="section-grid">
        <div class="solution-item">
          <img src="../assets/icone-home-1.png" alt="Consultoria em TI" />
          <p>Consultoria em TI</p>
        </div>
        <div class="solution-item">
          <img src="../assets/icone-home-2.png" alt="Desenvolvimento de Sistemas Personalizados" />
          <p>Desenvolvimento de Sistemas Personalizados</p>
        </div>
        <div class="solution-item">
          <img src="../assets/icone-home-3.png" alt="Soluções para Aplicativos Mobile" />
          <p>Soluções para Aplicativos Mobile</p>
        </div>
        <div class="solution-item">
          <img src="../assets/icone-home-4.png" alt="Integração de Sistemas" />
          <p>Integração de Sistemas</p>
        </div>
      </div>
    </section>

    <section class="section-como-podemos-ajudar">
      <div class="section-como-podemos-ajudar-2">
        <h2>Como podemos ajudar a sua empresa a crescer?</h2>
        <ul>
          <li v-for="(item, index) in helpItems" :key="index" :class="{ visible: itemVisible(index) }">
            <strong>{{ item.title }}</strong>
            <p>{{ item.description }}</p>
          </li>
        </ul>
        <div class="navegacao-ajuda">
          <span v-for="(item, index) in helpItems" :key="'dot-' + index" :class="{ active: visibleIndex === index }" @click="goToItem(index)" class="dot"></span>
        </div>
      </div>
      <div class="img-ajuda">
        <img src="../assets/img-home-1.jpg" alt="Imagem ilustrativa sobre a ajuda ao crescimento empresarial" />
      </div>
    </section>

    <section class="section-itens">
      <h2>Por que escolher a CATENA SYSTEM?</h2>
      <div class="section-grid">
        <div class="solution-item">
          <img src="../assets/icone-home-5.png" alt="Profissionais com mais de 20 anos de experiência" />
          <p>Profissionais com mais de 20 anos de experiência</p>
        </div>
        <div class="solution-item">
          <img src="../assets/icone-home-6.png" alt="Trabalhamos com tecnologias de ponta" />
          <p>Trabalhamos com tecnologias de ponta</p>
        </div>
        <div class="solution-item">
          <img src="../assets/icone-home-7.png" alt="Projetos de sucesso no setor público e privado" />
          <p>Projetos de sucesso no setor público e privado</p>
        </div>
        <div class="solution-item">
          <img src="../assets/icone-home-8.png" alt="Equipe especializada" />
          <p>Equipe especializada</p>
        </div>
      </div>
    </section>

    <section class="section-clientes">
      <h2>Nossos clientes</h2>
      <div class="logos-clientes">
        <div class="logo-cliente">
          <img src="../assets/cliente-1.png" alt="Ministério Público de Minas Gerais" />
        </div>
        <div class="logo-cliente">
          <img src="../assets/cliente-2.png" alt="Roboflex" />
        </div>
        <div class="logo-cliente">
          <img src="../assets/cliente-3.png" alt="Zontec" />
        </div>
        <div class="logo-cliente">
          <img src="../assets/cliente-4.png" alt="Zontec" />
        </div>
      </div>
    </section>

    <div class="banner-contato">
      <div class="banner-content">
        <p>Entre em contato para saber mais sobre como a CATENA SYSTEM pode ajudar sua empresa a alcançar os melhores resultados</p>

        <a href="https://wa.me/553189344230" target="_blank">
          <button class="cta-button">Vamos conversar?</button>
        </a>
      </div>
    </div>

    <section class="section-contato">
      <div class="contato-form">
        <h2>Estamos prontos para transformar suas ideias em soluções tecnológicas eficientes. Entre em contato agora!</h2>
        <FormContatoVue />
      </div>
    </section>
  </div>
</template>

<script>
import FormContatoVue from "@/components/FormContato.vue";

export default {
  components: {
    FormContatoVue,
  },
  data() {
    return {
      helpItems: [
        {
          title: "Redução de custos operacionais",
          description: "Ajudamos sua empresa a otimizar recursos, reduzindo despesas através da automação e digitalização de processos. Nossas soluções personalizadas garantem que você mantenha a eficiência operacional com menos custos, sem comprometer a qualidade e produtividade.",
        },
        {
          title: "Automatização de processos complexos",
          description: "Simplifique tarefas repetitivas e complexas com nossas soluções de automação. Desenvolvemos sistemas que permitem automatizar processos intrincados, eliminando falhas humanas e acelerando a execução de tarefas.",
        },
        {
          title: "Desenvolvimento ágil de software",
          description: "Nosso método de desenvolvimento ágil garante a entrega rápida e eficiente de softwares personalizados que atendem às necessidades do seu negócio.",
        },
        {
          title: "Melhoria de performance e eficiência",
          description: "Maximize o desempenho de seus sistemas e melhore a eficiência dos seus processos com nossas soluções tecnológicas.",
        },
      ],
      visibleIndex: 0,
    };
  },
  mounted() {
    this.animateItems();
  },
  methods: {
    animateItems() {
      setInterval(() => {
        this.visibleIndex = (this.visibleIndex + 1) % this.helpItems.length;
      }, 10000);
    },
    itemVisible(index) {
      return index === this.visibleIndex;
    },
    goToItem(index) {
      this.visibleIndex = index;
    },
  },
};
</script>

<style scoped>
.banner-home {
  background: url("../assets/banner-home.jpg") no-repeat center center/cover;
  width: 100vw;
  height: 100vh;
  min-height: 50vh;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-left: -50px;
}

.banner-contato {
  background: url("../assets/img-home-2.jpg") no-repeat center center/cover;
  width: 100vw;
  height: 80vh;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-left: -50px;
}

.banner-content h1 {
  font-size: 2.5em;
  margin-bottom: 10px;
}

.banner-content h2 {
  font-size: 1.8em;
  margin-bottom: 20px;
}

.banner-content p {
  font-size: 1.2em;
  margin-bottom: 30px;
}

.cta-button {
  padding: 15px 30px;
  background-color: #9dee9c;
  border: none;
  color: #274862;
  font-size: 1em;
  cursor: pointer;
  border-radius: 5px;
  font-weight: 600;
}

.cta-button:hover {
  background-color: #82c582;
}

.banner-content {
  background-color: #274862;
  color: white;
  padding: 50px 10px 50px 80px;
  text-align: left;
  max-width: 600px;
  border-radius: 0px 16px 16px 0px;
  opacity: 0.85;
}

.solution-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 240px;
}

.solution-item img {
  width: 80px;
  margin-bottom: 20px;
}

.solution-item p {
  font-size: 1.2em;
}

.section-como-podemos-ajudar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f5f5f5;
  color: #274862;
  padding: 0px 0px;
}

.section-como-podemos-ajudar h2 {
  font-size: 2em;
  margin-bottom: 20px;
  text-align: left;
}

.como-podemos-ajudar-text {
  max-width: 50%;
  padding: 0px 150px 0px 100px;
}

.section-como-podemos-ajudar ul {
  list-style: none;
  padding: 0;
  margin: 0;
  position: relative;
  height: 150px;
}

.section-como-podemos-ajudar li {
  position: absolute;
  opacity: 0;
  width: 100%;
  top: 0;
  left: 0;
  text-align: left;
  transition: opacity 0.5s ease-in-out;
  padding: 20px 0px;
}

.section-como-podemos-ajudar li.visible {
  opacity: 1;
}

.section-como-podemos-ajudar li p {
  font-size: 1em;
  line-height: 1.6;
}

.section-como-podemos-ajudar-2 {
  padding-left: 50px;
}

.img-ajuda img {
  max-width: 700px;
}

.section-clientes {
  text-align: center;
  padding-bottom: 80px;
}

.section-clientes h2 {
  font-size: 2em;
  margin-bottom: 100px;
  color: #274862;
}

.logos-clientes {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 200px;
  flex-wrap: wrap;
}

.logo-cliente img {
  max-width: 200px;
  height: auto;
  filter: grayscale(100%);
  transition: filter 0.3s ease-in-out, opacity 0.3s ease-in-out;
  opacity: 0.8;
}

.logo-cliente img:hover {
  filter: grayscale(0%);
  opacity: 1;
}

.navegacao-ajuda {
  display: flex;
  justify-content: left;
  margin-top: 30px;
}

.dot {
  height: 15px;
  width: 15px;
  margin: 0 5px;
  background-color: #bbb;
  border-radius: 50%;
  display: inline-block;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.dot.active {
  background-color: #274862;
}

.section-contato {
  background-color: #f5f5f5;
  padding: 40px 20px;
  text-align: center;
}

.contato-form h2 {
  font-size: 1.8em;
  margin-bottom: 20px;
  margin-left: 300px;
  margin-right: 300px;
  color: #274862;
}

@media (max-width: 1024px) {
  .banner-content h1 {
    font-size: 2.2em;
  }

  .banner-content h2 {
    font-size: 1.6em;
  }

  .banner-content p {
    font-size: 1.1em;
  }

  .section-itens h2,
  .section-clientes h2,
  .contato-form h2 {
    font-size: 1.6em;
  }

  .contato-form h2 {
    margin: 0 100px;
  }

  .solution-item img {
    width: 70px;
  }

  .solution-item p {
    font-size: 1.1em;
  }
}

@media (max-width: 768px) {
  .banner-home {
    height: 60vh;
    padding-left: 20px;
    min-height: 40px;
  }

  .banner-content {
    max-width: 90%;
    padding: 30px 20px;
  }

  .banner-home-p p {
    font-size: 1em;
    line-height: 1.4;
  }

  .cta-button {
    padding: 12px 20px;
    font-size: 0.9em;
  }

  .banner-content {
    max-width: 90%;
    padding: 20px;
  }

  .banner-content h1 {
    font-size: 1.8em;
  }

  .banner-content h2 {
    font-size: 1.4em;
  }

  .banner-content p {
    font-size: 1em;
  }

  .cta-button {
    padding: 12px 20px;
    font-size: 0.9em;
  }

  .section-itens h2 {
    font-size: 1.4em;
    margin-bottom: 40px;
  }

  .section-grid {
    flex-direction: column;
    align-items: center;
  }

  .solution-item img {
    width: 60px;
  }

  .solution-item p {
    font-size: 1em;
  }

  .section-como-podemos-ajudar {
    flex-direction: column;
    text-align: center;
    padding: 20px;
  }

  .como-podemos-ajudar-text {
    max-width: 100%;
    padding: 0px;
  }

  .como-podemos-ajudar-text h2 {
    font-size: 1.6em;
  }

  .como-podemos-ajudar-text li p {
    font-size: 0.9em;
  }

  .img-ajuda img {
    max-width: 100%;
    margin-top: 10px;
  }

  .section-clientes h2 {
    font-size: 1.5em;
    margin-bottom: 50px;
  }

  .logos-clientes {
    gap: 50px;
  }

  .logo-cliente img {
    max-width: 120px;
  }

  .contato-form h2 {
    margin-left: 20px;
    margin-right: 20px;
  }
}

@media (max-width: 480px) {
  .banner-home {
    min-height: 80vh;
  }

  .banner-content {
    padding: 20px;
  }

  .banner-home-p p {
    font-size: 0.9em;
    line-height: 1.3;
  }

  .cta-button {
    font-size: 0.8em;
    padding: 8px 16px;
  }

  .banner-content h1 {
    font-size: 1.3em;
  }

  .banner-content h2 {
    font-size: 1.1em;
  }

  .banner-content p {
    font-size: 0.8em;
  }
  .section-itens {
    padding: 5px;
  }
  .section-como-podemos-ajudar {
    padding: 5px;
  }

  .section-como-podemos-ajudar h2 {
    font-size: 1.2em;
  }
  .section-como-podemos-ajudar-2 {
    padding-bottom: 100px;
  }
  .navegacao-ajuda {
    padding-top: 90px;
  }
  .contato-form {
    margin: 10px;
  }
}
</style>
